import React, { useState } from 'react'

const RetantionTable = () => {
    const [data, setData] = useState('subscribers')

    return (
        <div>
            <span className='text-sm text-[#414552] font-semibold pb-[16px]'>Retention by cohort</span>
            <div className="flex text-[14px] gap-[14px] font-semibold border-b-[1px] mt-2 border-[#d5dbe1]">
                <button className={`${data === "subscribers" ? "border-[#625afa] text-[#625afa]" : "border-transparent text-[#687385]"} border-b-[2px] py-[8px] capitalize`} onClick={() => setData('subscribers')}>subscribers</button>
                <button className={`${data === "revenue" ? "border-[#625afa] text-[#625afa]" : "border-transparent text-[#687385]"} border-b-[2px] py-[8px] capitalize`} onClick={() => setData('revenue')}>revenue</button>
            </div>
            <div className='mt-2 w-full overflow-x-auto'>
                <table className='revenue-table md:w-full w-[730px] overflow-x-auto table-auto'>
                    <thead>
                        <tr>
                            <th>Subscribed</th>
                            <th>Start {data === "subscribers" ? "value" : "MRR"}</th>
                            <th>Month 1</th>
                            <th>Month 2</th>
                            <th>Month 3</th>
                            <th>Month 4</th>
                            <th>Month 5</th>
                            <th>Month 6</th>
                            <th>Month 7</th>
                            <th>Month 8</th>
                            <th>Month 9</th>
                            <th>Month 10</th>
                            <th>Month 11</th>
                            <th>Month 12</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                        <tr>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td className='white'><div className='flex justify-end'><div /></div></td>
                            <td></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                            <td className='white'></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default RetantionTable